import router, { resetRouter } from './router'
import store from './store'

const whiteList = ['login']

router.beforeEach(async (to, from, next) => {
  if (store.getters.authKey && store.getters.sessionId) {
    if (whiteList.includes(to.name)) {
      next({ path: store.getters.menus?.[0]?.path || '/' })
    } else {
      if (store.getters.menus && store.getters.menus.length > 0) {
        if (to.path === '/404' && from.path == '/sys/digitalSignage') {
          next({ path: '/sys/echart', replace: true })
        } 
        else if (to.path === '/') {
          next({ path: store.getters.menus[0].path || '/' })
        } 
        else {
          next()
        }
      } else {
        const routes = await store.dispatch('setMenus')

        resetRouter()
        if (Array.isArray(routes)) {
          routes.forEach(route => router.addRoute(route))
        }
        router.addRoute({
          path: '*',
          redirect: '/404'
        })

        if (from.path === '/login') {
          const firstPath = routes?.[0]?.path || '/sys/echart'
          next({ path: firstPath, replace: true })
        } else {
          const routeExists = router.getRoutes().some(r => r.path === to.path)
          next(routeExists ? { ...to, replace: true } : '/sys/echart')
        }
      }
    }
  } else {
    if (whiteList.includes(to.name)) {
      next()
    } else {
      next({ path: '/login' })
    }
  }
});
